module.exports = __webpack_public_path__ + "static/media/TermsAndConditons.f4087f80.pdf";